import React from 'react';

/* A note when using this component - you will need to pass a fill color if you want anything other than black. */

const IconProfileTh = props => (
  <svg viewBox="0 0 22 22.4" {...props}>
    <title>Profile</title>
    <path d="M10 9.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm-8.5 12a.5.5 0 1 1-1 0V17A5.5 5.5 0 0 1 6 11.5h8a5.5 5.5 0 0 1 5.5 5.5v3.5a.5.5 0 1 1-1 0V17a4.5 4.5 0 0 0-4.5-4.5H6A4.5 4.5 0 0 0 1.5 17v3.5z" />
  </svg>
);

export default IconProfileTh;
